export const USER_ROLE = {
  Client: 'CLIENT',
  CourtReporter: 'COURT_REPORTER',
  ThirdParty: 'THIRD_PARTY',
};

export const FORM_ERROR = {
  TextMaxLength: 'Name must be less than 255 characters.',
  TextShortMaxLength: 'Name must be less than 150 characters.',
  RequiredField: 'Field cannot be blank.',
  EmailFormat: 'Wrong Email Format.',
  EmailLength: 'Email must be less than 50 characters.',
  IDLength: 'ID must be less than 50 characters.',
};

export const PARTIES_ERROR_MESSAGES = {
  REQUIRED: 'Parties are required.',
  QUANTITY: 'Parties should have one Court Reporter and at least one Client.',
};
